import AlertsDrawerComponent from './alertsDrawer'
import ProfileDrawerComponent from './profileDrawer'
import ProductsDrawerComponent from './productsDrawer'

export const AlertsDrawer = AlertsDrawerComponent;
export const ProfileDrawer = ProfileDrawerComponent;
export const ProductsDrawer = ProductsDrawerComponent;